module.exports = __webpack_public_path__ + "img/3.9c2f09cc.jpg";